import styled from 'styled-components';

export const UiVideoIcon = styled.div`
	display: flex;
	align-items: center;
	width: 35px;
	height: 35px;
`;
